import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { RequireEntitlements } from '@/components/Auth/RequireEntitlements';
import { RequireGeneratedContext } from '@/components/Auth/RequireGeneratedContext';
import { ByomSection } from '@/components/Settings/Byom/ByomSection';
import { SettingsPageLayout } from '@/components/Settings/SettingsPageLayout';
import { useUser } from '@/hooks/useUser';

export const Route = createFileRoute('/$organizationName/settings/byom')({
  component: SecuredByomPage,
});

function SecuredByomPage() {
  return (
    <RequireGeneratedContext>
      <RequireEntitlements admins={['isSuperAdmin']}>
        <ByomPage />
      </RequireEntitlements>
    </RequireGeneratedContext>
  );
}

function ByomPage() {
  const { organizationDisplayName } = useUser();

  useEffect(() => {
    document.title = `${organizationDisplayName || 'Driver'} - Models`;
  }, [organizationDisplayName]);

  return (
    <SettingsPageLayout
      title="Models"
      subTitle="Bring your own model providers and credentials"
      innerClassName="max-w-7xl"
    >
      <ByomSection />
    </SettingsPageLayout>
  );
}
